// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsSelector_container__aVDA_","selector":"TermsSelector_selector__YC3JR"};